import { MapLatLng } from '../models/map.latlng';
import { MapPolyline } from '../models/map.polyline';
import { MapPolylinePoint } from '../models/map.polylinePoint';
import { HMapComponent } from './hmap.component';

declare var H: any;

export class HPolyline extends MapPolyline {
    private lineString: any;
    private hMap: HMapComponent;

    constructor(id: number, map: any, color: string, opacity: number, weight: number, hMap: HMapComponent) {
        super(id, map, color, opacity, weight);
        this.hMap = hMap;
        this.lineString = new H.geo.LineString();
    }

    // Añade un punto a una polilinea
    addPoint(id: number, content: string, position: MapLatLng): MapPolylinePoint {
        const point = new MapPolylinePoint(id, content, position);
        this.lineString.pushPoint({ lat: position.lat, lng: position.lng });
        this.points.push(point);
        if (this.points.length === 2) {
            this.polyline = new H.map.Polyline(
                this.lineString, {
                volatility: true,
                style: {
                    lineWidth: this.weight,
                    strokeColor: this.hex2rgba(this.color, this.opacity)
                }
            });
            this.polyline.setData({ id: id, content: content });
            this.map.addObject(this.polyline);
        }
        if (this.polyline) {
            this.polyline.setGeometry(this.lineString);
        }
        return point;
    }

    // Borra la polilinea
    remove() {
        if (this.polyline) {
            this.map.removeObject(this.polyline);
            this.polyline = null;
        }
    }

    // Transforma un color en formato hex(rgb) en rgba(r,g,b,a)
    hex2rgba(hex: any, alpha = 1) {
        const [r, g, b] = hex.match(/\w\w/g).map((x: any) => parseInt(x, 16));
        return `rgba(${r},${g},${b},${alpha})`;
    }

    // Devuelve el punto de la polininea más cercano a un punto dado
    public getNearbyPoint(position: any): any {
        let res: MapPolylinePoint | undefined;
        let i = 0, index = 0;
        let oldDist = 99999999;
        let lastPoint: MapPolylinePoint | undefined;
        for (i = 0; i < this.points.length; i++) {
            if (lastPoint) {
                const dist = this.hMap.distancePointToSegment(lastPoint.point.lng, lastPoint.point.lat, this.points[i].point.lng,
                    this.points[i].point.lat, position.lng, position.lat);
                if (dist < oldDist) {
                    index = i;
                    oldDist = dist;
                }
            }
            lastPoint = this.points[i];
        }
        if (index > 0) {
            if (this.hMap.dist(position.lng, position.lat, this.points[index].point.lng, this.points[index].point.lat) <
                this.hMap.dist(position.lng, position.lat, this.points[index - 1].point.lng, this.points[index - 1].point.lat)) {
                res = this.points[index];
            } else {
                res = this.points[index - 1];
            }
        }
        return res;
    }

}
